import { useSocialLinks } from 'app/hooks/use-social-links';
import { IconHeartHandshake } from '@tabler/icons-react-native';
import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useTheme } from 'app/shopify';
import type { Listing } from 'app/types/listing';
import { ListingType } from 'app/types/listing';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useTranslation } from 'react-i18next';

/** Exclusive audience comes from the API, never from viewer-filtered group arrays. */
export function TrustCircleListingBanner({ listing, detail = false }: { listing: Listing; detail?: boolean }) {
  const { t } = useTranslation('one-listing');
  const theme = useTheme();
  const socialLinks = useSocialLinks();
  if (!socialLinks.enabled || !listing.isTrustCircleOnly) return null;
  const isRequest = listing.type === ListingType.request;
  return (
    <Row
      backgroundColor="surface.brand.secondary-4.subtle"
      alignItems="center"
      justifyContent={detail ? 'flex-start' : 'center'}
      gap={detail ? 'spacing.general.x3' : 'spacing.general.x1'}
      paddingHorizontal={detail ? 'spacing.general.x4' : 'spacing.general.x2'}
      paddingVertical={detail ? 'spacing.general.x4' : 'spacing.general.x1'}
      minHeight={detail ? 64 : 34}
      pointerEvents="none"
    >
      <IconHeartHandshake
        size={detail ? 26 : 20}
        color={theme.colors['text.primary']}
        strokeWidth={ICON_STROKE_WIDTH}
      />
      <Text color="text.primary" fontSize={detail ? 16 : 14} fontWeight={detail ? '400' : '600'} flexShrink={1}>
        {detail
          ? t(isRequest ? 'trustCircle.requestExplanation' : 'trustCircle.offerExplanation', {
              name: listing.user.profile.firstName,
            })
          : t(isRequest ? 'trustCircle.requestLabel' : 'trustCircle.offerLabel')}
      </Text>
    </Row>
  );
}
